module.exports = __webpack_public_path__ + "img/c02_buildingstrengthofthegods_Normal_ua.0fd3b8da.webp";